import React, { useState, useEffect, useRef, useCallback } from "react";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { styled } from "@mui/material/styles";
import { useSelector, useDispatch } from "react-redux";
import {
  fillAzureCredentials,
  uploadDocumentsFunc,
  uploadDocumentToS3Func,
  clearUploadedDocumentsError,
  resetdocumentS3Data
} from "./redux/DocumentViewerSlicer";
import { toast } from "react-toastify";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import {
  Box,
  Container,
  TextField,
  Typography,
  Button,
  Grid,
  Paper,
  IconButton,
  InputAdornment,
  Divider,
  Tooltip,
  Dialog,
  LinearProgress,
  Toolbar,
} from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import SecurityIcon from "@mui/icons-material/Security";
import { useNavigate } from "react-router-dom";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const UploadDocuments = ({ docuType }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const toastShown = useRef(false);
  const {
    uploadedDocumentsLoading,
    uploadedDocumentsData,
    uploadedDocumentsError,
  } = useSelector((state) => state.documentViewer.loadedDocuments);

  const {
    uploadedS3DocumentLoading,
    uploadedS3DocumentData,
    uploadedS3DocumentError,
  } = useSelector((state) => state.documentViewer.uploadedS3DocumentObj);
  const [uploadedDocuments, setUploadedDocuments] = useState([]);
  const [documentUploadPercent, setDocumentUploadPercent] = useState(0);
  const [openForm, setOpenForm] = useState(false);
  const [showSecret, setShowSecret] = useState(false);
  const [currentDocumentProcessing, setCurrentDocumentProcessing] =
    useState(null);
  const azureFormStatus = sessionStorage.getItem("azureFormStatus");
  const mediaQuery = window.matchMedia("(max-width: 900px)");
  const [formValues, setFormValues] = useState({
    endPoint: "",
    accessKey: "",
    tenantId: "",
    clientId: "",
    clientSecret: "",
    subscriptionId: "",
    resourceGroup: "",
    accountName: "",
  });
  const docProcessordevEnv = process.env.REACT_APP_FLAG_DEV;
  const docProcessorusaEnv = process.env.REACT_APP_FLAG_USA;
  const docProcessorinternalEnv = process.env.REACT_APP_FLAG_INTERNAL;

  const handleChange = (e) => {
    setFormValues({ ...formValues, [e.target.name]: e.target.value });
  };

  const handleOpenForm = () => setOpenForm(true);
  const handleCloseForm = () => setOpenForm(false);

  useEffect(() => {
    
    if (!uploadedDocumentsLoading) {
      setDocumentUploadPercent(100);
    }

    let timer;
    if (uploadedDocumentsLoading) {
      setDocumentUploadPercent(0);
      timer = setInterval(() => {
        setDocumentUploadPercent((oldProgress) => {
          if (oldProgress >= 90) {
            return oldProgress;
          }
          return oldProgress + 10;
        });
      }, 300);
    }
    return () => {
      clearInterval(timer);
    };
  }, [uploadedDocumentsLoading]);


  useEffect(() => {
    if (uploadedDocumentsError) {
      toast.error(uploadedDocumentsError);
      dispatch(clearUploadedDocumentsError());
    }
  }, [uploadedDocumentsError, dispatch]);

  useEffect(() => {
    if (uploadedDocumentsData && uploadedDocumentsData?.length > 0 && !toastShown?.current) {
      // console.log(uploadedDocumentsData, 'uploadedDocumentsData')
      toast.success(`Documents Uploaded Successfully!`);
      toastShown.current = true;
      let documentCount = 0;

      const intervalId = setInterval(() => {
        const document = uploadedDocumentsData[documentCount];
        // console.log(document, 'document')
        setCurrentDocumentProcessing(document);
        const { url, fields } = document?.response;
        // console.log(url, fields, 'fields');
        const keyFileName = fields?.key?.split("/")?.pop(); // "contract123.pdf"
        const file = uploadedDocuments?.filter((item) => item?.name?.includes(keyFileName));
      const formData = new FormData();
      Object.keys(fields)?.forEach((key) => {
        formData.append(key, fields[key]);
      });
      // console.log(file, 'file')
      formData.append("file", file[0]);
        if (!uploadedDocumentsLoading && document) {
          dispatch(uploadDocumentToS3Func({ url, formData}))
        }
        documentCount++;
        if (documentCount >= uploadedDocuments?.length) {
          clearInterval(intervalId);
        }
      }, 3000);
    }
  }, [uploadedDocumentsData]);
  

  useEffect(() => {
    setTimeout(() => {
      if(!uploadedS3DocumentLoading && uploadedS3DocumentData != null && currentDocumentProcessing != null){
      const keyFileName = currentDocumentProcessing?.response?.fields?.key?.split("/")?.pop();
      console.log(keyFileName, 'keyFileName')
      setUploadedDocuments(prevDocs =>
        prevDocs?.filter(doc => doc?.name !== keyFileName)
      );      
      // console.log("currentDocumentProcessing", keyFileName)
      toast.success(`Document ${keyFileName} uploaded successfully.`);
      dispatch(resetdocumentS3Data());
    }
    }, 2000)
  }, [uploadedS3DocumentData])

//   useEffect(() => {
//   const timeoutId = setTimeout(() => {
//     // console.log(uploadedS3DocumentData, 'uploadedS3DocumentData')
//     if (!uploadedS3DocumentLoading && uploadedS3DocumentData != null && uploadedS3DocumentData?.status === 204 ) {
//       const keyFileName = currentDocumentProcessing?.response?.fields?.key?.split("/")?.pop();
//       setUploadedDocuments(prevDocs =>
//         prevDocs?.filter(doc => doc?.name !== keyFileName)
//       );
//       toast.success(`Document "${keyFileName}" uploaded successfully.`);
//       // dispatch(resetdocumentS3Data());
//     }
//   }, 2000);

//   return () => clearTimeout(timeoutId);
// }, [uploadedS3DocumentLoading, uploadedS3DocumentData, dispatch]);

  const documentsUploadHandler = (event) => {
    const files = Array.from(event.target.files);
    const filterDocuments = files?.filter(
      (file) => file?.name?.includes("-") && file?.name
    );
    const documentNamesToUpload = filterDocuments?.map(
      (docuement) => docuement?.name
    );
    const invalidDocuments = files?.filter(
      (file) => !file?.name?.includes("-") && file?.name
    )?.map((doc) => doc?.name);
    // console.log(invalidDocuments, 'invalidDocuments')
    if (invalidDocuments?.length > 0) {
      toast.error(
        `Invalid file ${invalidDocuments?.length === 1 ? "name" : "names"} ${invalidDocuments?.join(
          ", "
        )}. Each file must include a hyphen.`
      );
    }
    if (filterDocuments?.length > 8) {
      toast.error("You can upload only up to 8 files");
    } else {
      if (documentNamesToUpload?.length > 0) {
        dispatch(uploadDocumentsFunc({ file_names: documentNamesToUpload }));
        setUploadedDocuments(filterDocuments);
      }
    }
  };

//   const documentsUploadHandler = useCallback(
//   debounce((event) => {
//     const files = Array.from(event.target.files);
//     const validDocuments = files?.filter((file) => file?.name?.includes("-"));
//     const invalidDocuments = files?.filter((file) => !file?.name?.includes("-"));

//     if (invalidDocuments?.length > 0) {
//       const invalidNames = invalidDocuments?.map((doc) => doc?.name)?.join(", ");
//       toast.error(
//         `Invalid file names: ${invalidNames}. Each file must include a hyphen.`
//       );
//     }

//     if (validDocuments?.length > 8) {
//       toast.error("You can upload only up to 8 files");
//       return;
//     }

//     if (validDocuments?.length > 0) {
//       const fileNames = validDocuments?.map((file) => file?.name);
//       setUploadedDocuments(fileNames);
//       dispatch(uploadDocumentsFunc({ file_names: fileNames }));
//     }
//   }, 500),
//   []
// );


  // const uploadDocumentToS3 = () => {
  //   console.log(uploadedDocumentsData, "uploadedDocumentsData");
  // };

  const handleDocProcessorFormFill = () => {
    dispatch(fillAzureCredentials(formValues)).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        toast.success("Form submitted successfully");
        sessionStorage.setItem("azureFormStatus", true);
        setOpenForm(false);
      } else {
        toast.error(res.payload || "Failed to enter credentials");
      }
    });
  };

  const uploadSection = (
    <Paper
      elevation={3}
      sx={{
        p: 4,
        borderRadius: 4,
        overflowY:'auto',
        height:'100%',
        minHeight: "400px",
        opacity: !azureFormStatus && docuType ? 0.5 : 1,
        pointerEvents: !azureFormStatus && docuType ? "none" : "auto", // disables interaction
      }}
    >
      <Typography variant="h6" fontWeight="bold" mb={2}>
        Upload and attach files
      </Typography>
      <Divider />

      <Box sx={{ mt: 3 }}>
        <Box
          sx={{
            height: 180,
            borderRadius: 2,
            border: "2px dashed #ccc",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            bgcolor: "#f9f9f9",
            px: 2,
          }}
        >
          <Button
            component="label"
            variant="outlined"
            startIcon={<CloudUploadIcon />}
            sx={{
              textTransform: "none",
              borderColor: "#aaa",
              color: "#333",
              fontWeight: 500,
              backgroundColor: "white",
              "&:hover": {
                backgroundColor: "#f1f1f1",
                borderColor: "#888",
              },
            }}
          >
            Import File
            <VisuallyHiddenInput
              type="file"
              onChange={documentsUploadHandler}
              multiple
              accept="application/pdf"
            />
          </Button>

          <Box
            sx={{
              mt: 1,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography sx={{ fontSize: 12, color: "text.secondary" }}>
              Supported format: PDF
            </Typography>

            <Typography sx={{ fontSize: 12, color: "text.secondary" }}>
              You can upload up to 8 files
            </Typography>

            <Typography sx={{ fontSize: 12, color: "text.secondary" }}>
              Files uploaded:{" "}
              {uploadedDocuments?.length > 0 ? uploadedDocuments?.length : 0} /
              8
            </Typography>
            <Typography
              sx={{ fontSize: 12, color: "red", textAlign: "center" }}
            >
              Expected file format episode-identifier-pdfname.pdf
            </Typography>
          </Box>
        </Box>

        {uploadedDocuments &&
          uploadedDocuments?.map((document, index) => (
            <Box
              key={index}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                mt: 3,
                p: 2,
                border: "1px solid #ddd",
                borderRadius: 2,
                bgcolor: "#fff",
              }}
            >
              <UploadFileIcon sx={{ fontSize: 32, color: "#555" }} />
              <Box sx={{ flexGrow: 1 }}>
                <Typography fontSize={14} mb={1}>
                  {document.name}
                </Typography>
                <LinearProgress
                  variant="determinate"
                  value={documentUploadPercent}
                  sx={{ height: 8, borderRadius: 5 }}
                />
              </Box>

              <Typography
                variant="body2"
                sx={{ minWidth: 40, textAlign: "right" }}
              >
                {documentUploadPercent}%
              </Typography>
            </Box>
          ))}
      </Box>
    </Paper>
  );

  const iframeLink = docProcessordevEnv ? "https://doc-dev.imedx.com.au/frontend" : docProcessorusaEnv ? "https://doc-usa.imedx.com.au/frontend" : docProcessorinternalEnv ? "https://doc-internal.imedx.com.au/frontend" : ""
  return (
    <>
      {/* Disclaimer Section */}
      <Container maxWidth={false}>
        <Box
          sx={{
            bgcolor: "#fff8e1", // Light golden
            border: "1px solid #ffecb3",
            px: 4,
            py: 3,
            borderRadius: 2,
            mt: 3,
            display: "flex",
            alignItems: "flex-start",
            gap: 2,
          }}
        >
          {" "}
          <WarningAmberIcon sx={{ color: "#f9a825", mt: "2px" }} />
          <Typography variant="body2" sx={{ color: "#5d4037", mt: 0.5 }}>
            You may upload your documents at your own discretion. Please note
            that even sensitive documents will be processed within our secured
            environment. By uploading, you{" "}
            <strong>acknowledge and accept</strong> any associated risks.
          </Typography>
        </Box>

        {/* Additional note for scanned documents */}
        {!azureFormStatus && docuType && (
          <Box
            sx={{
              mt: 2,
              px: 4,
              py: 2,
              bgcolor: "#e3f2fd",
              border: "1px solid #bbdefb",
              borderRadius: 2,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: "10px",
              flexDirection: { xs: "column", md: "row" },
            }}
          >
            <Typography variant="body2" sx={{ color: "#0d47a1" }}>
              If you're uploading <strong>scanned documents</strong>, it is{" "}
              <strong>mandatory</strong> to fill out the verification form with
              your Azure credentials. Without this, we will not be able to
              process your scanned documents.
            </Typography>

            <Button
              variant="contained"
              size="small"
              sx={{
                mt: 1,
                backgroundColor: "#1976d2 ",
                "&:hover": { backgroundColor: "#115293" },
                width: { xs: "100%", md: "20%" },
              }}
              onClick={handleOpenForm} // Your handler to open form modal or route
            >
              Fill the form
            </Button>
          </Box>
        )}
      </Container>

      {/* Main Container */}
      <Container
        maxWidth={false}
        sx={{
          width: "100%",
          minHeight: "65vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          py: 2,
          height:
            !azureFormStatus && docuType
              ? "calc(100vh - 250px)"
              : "calc(100vh - 160px)",
        }}
      >
        <Box
          sx={{
            display: "flex",
            width: "100%",
            height: "100%",
            gap: 4,
            flexDirection: { xs: "column", md: "row" },
          }}
          // className="upload-doc-wrapper"
        >
          {/* 30% Section */}
          {!azureFormStatus && docuType ? (
            <Tooltip title="Please fill the form first" arrow>
              <div>{uploadSection}</div>
            </Tooltip>
          ) : (
            uploadSection
          )}

          {/* 70% Section */}
          <Paper
            elevation={3}
            sx={{
              width: { xs: "100%", md: "80%" },
              // flexDirection: { xs: "column", md: "row" },
            }}
          >
            <iframe
              src={iframeLink}
              className="doc-processor-iframe"
              width="100%"
              // height="100%"
              style={{height:mediaQuery.matches ? "100vh":"100%"}}
            ></iframe>
          </Paper>
        </Box>
      </Container>
      <Dialog open={openForm} onClose={handleCloseForm} fullWidth maxWidth="sm">
        <Box
          display="flex"
          justifyContent="center"
          className="doc-processor-form"
        >
          <Paper elevation={3} sx={{ p: 4 }}>
            <Box display="flex" alignItems="center" mb={1}>
              <LockIcon color="primary" sx={{ mr: 1 }} />
              <Typography variant="h6">Azure Credentials</Typography>
            </Box>

            <Typography variant="body2" color="text.secondary" mb={2}>
              Please enter your Azure credentials below. These will be used to
              authenticate your account securely.
            </Typography>

            {/* <Box display="flex" alignItems="center" mb={2}>
              <InfoOutlinedIcon
                color="warning"
                fontSize="small"
                sx={{ mr: 1 }}
              />
              <Typography variant="caption" color="warning.main">
                Credentials are mandatory to process scanned documents.
              </Typography>
            </Box> */}
            <TextField
              fullWidth
              name="endPoint"
              label="End Point"
              value={formValues.endPoint}
              onChange={handleChange}
              margin="6px"
              sx={{
                "& .MuiInputBase-input": {
                  fontSize: "0.85rem",
                },
                "& .MuiInputLabel-root": {
                  fontSize: "0.8rem",
                },
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Tooltip title="Azure Endpoint">
                      <InfoOutlinedIcon fontSize="small" />
                    </Tooltip>
                  </InputAdornment>
                ),
              }}
            />
            <TextField
              fullWidth
              name="accessKey"
              label="Access Key"
              value={formValues.accessKey}
              onChange={handleChange}
              margin="normal"
              sx={{
                "& .MuiInputBase-input": {
                  fontSize: "0.85rem",
                },
                "& .MuiInputLabel-root": {
                  fontSize: "0.8rem",
                },
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end" style={{ fontSize: "10px" }}>
                    <Tooltip title="Azure Access Key">
                      <InfoOutlinedIcon fontSize="small" />
                    </Tooltip>
                  </InputAdornment>
                ),
              }}
            />

            <TextField
              fullWidth
              name="tenantId"
              label="Tenant ID"
              value={formValues.tenantId}
              onChange={handleChange}
              margin="normal"
              sx={{
                "& .MuiInputBase-input": {
                  fontSize: "0.85rem",
                },
                "& .MuiInputLabel-root": {
                  fontSize: "0.8rem",
                },
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Tooltip title="Directory (tenant) ID">
                      <InfoOutlinedIcon fontSize="small" />
                    </Tooltip>
                  </InputAdornment>
                ),
              }}
            />

            <TextField
              fullWidth
              name="clientId"
              label="Client ID"
              value={formValues.clientId}
              onChange={handleChange}
              sx={{
                "& .MuiInputBase-input": {
                  fontSize: "0.85rem", // or any size like '12px'
                },
                "& .MuiInputLabel-root": {
                  fontSize: "0.8rem",
                },
              }}
              margin="normal"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Tooltip title="App registration client ID">
                      <InfoOutlinedIcon fontSize="small" />
                    </Tooltip>
                  </InputAdornment>
                ),
              }}
            />
            <Grid container spacing={2} mt={1} sx={{ width: "100%" }}>
              <Grid item xs={6} sx={{ width: "48%" }}>
                <TextField
                  fullWidth
                  name="clientSecret"
                  label="Client Secret"
                  type={showSecret ? "text" : "password"}
                  value={formValues.clientSecret}
                  onChange={handleChange}
                  margin="normal"
                  sx={{
                    "& .MuiInputBase-input": {
                      fontSize: "0.85rem", // or any size like '12px'
                    },
                    "& .MuiInputLabel-root": {
                      fontSize: "0.8rem",
                    },
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowSecret(!showSecret)}
                          edge="end"
                          aria-label="toggle password visibility"
                        >
                          {showSecret ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={6} sx={{ width: "48%" }}>
                <TextField
                  fullWidth
                  name="accountName"
                  label="Account Name"
                  value={formValues.accountName}
                  onChange={handleChange}
                  margin="normal"
                  sx={{
                    "& .MuiInputBase-input": {
                      fontSize: "0.85rem",
                    },
                    "& .MuiInputLabel-root": {
                      fontSize: "0.8rem",
                    },
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <Tooltip title="Azure Account Name">
                          <InfoOutlinedIcon fontSize="small" />
                        </Tooltip>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
            </Grid>

            <Grid container spacing={2} mt={1} sx={{ width: "100%" }}>
              <Grid item xs={6} sx={{ width: "48%" }}>
                <TextField
                  fullWidth
                  name="subscriptionId"
                  label="Subscription ID"
                  sx={{
                    "& .MuiInputBase-input": {
                      fontSize: "0.85rem", // or any size like '12px'
                    },
                    "& .MuiInputLabel-root": {
                      fontSize: "0.8rem",
                    },
                    width: "100%",
                  }}
                  value={formValues.subscriptionId}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={6} sx={{ width: "48%" }}>
                <TextField
                  fullWidth
                  name="resourceGroup"
                  sx={{
                    "& .MuiInputBase-input": {
                      fontSize: "0.85rem", // or any size like '12px'
                    },
                    "& .MuiInputLabel-root": {
                      fontSize: "0.8rem",
                    },
                    width: "100%",
                  }}
                  label="Resource Group Name"
                  value={formValues.resourceGroup}
                  onChange={handleChange}
                />
              </Grid>
            </Grid>

            {/* 
            <Box display="flex" alignItems="center" mt={2}>
              <SecurityIcon fontSize="small" sx={{ mr: 1 }} />
              <Typography variant="caption" color="text.secondary">
                Your credentials are encrypted and not shared.
              </Typography>
            </Box> */}

            <Box mt={3} display="flex" justifyContent="space-between">
              <Button
                variant="outlined"
                onClick={handleCloseForm}
                style={{ fontSize: "13px" }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color="primary"
                style={{ fontSize: "13px" }}
                onClick={handleDocProcessorFormFill}
              >
                Save & Continue
              </Button>
            </Box>
          </Paper>
        </Box>
      </Dialog>
    </>
  );
};

export default UploadDocuments;
